const ingredients = document.querySelector('.single-recipe__ingredients ul');

if (ingredients) {
  const items = ingredients.querySelectorAll('li');
  const targetWords = /(beef|steak|roast|rib|meat|brisket)/i;

  items.forEach((item) => {
    const text = item.textContent;
    const containsTargetWord = targetWords.test(text);

    if (containsTargetWord) {
      item.addEventListener('click', (event) => {

        if (event.target.matches('input[type="checkbox"]')) {
          const checkbox = event.target;

          if (checkbox.checked) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: 'beefIngredientClick',
              ingredient: text.trim()
            });
          }
        }
      });
    }
  });
}
